import { render } from "./PriceInputs.vue?vue&type=template&id=7c3936e2"
import script from "./PriceInputs.vue?vue&type=script&lang=js"
export * from "./PriceInputs.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__